import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { RouterModule } from "@angular/router";

import { ScrollToService } from "../../core";
import { FlexBoxModule } from "../flex-box";
import { LinkModule } from "../link";
import {
  IconModule,
  UserActionDirectivesModule
} from "../utils";
import { SectionComponent } from "./section.component";
import { SidebarProjectedContentComponent } from "./sidebar-projected-content.component";
import { SidebarComponent } from "./sidebar.component";
import { SubsectionHeaderItemComponent } from "./subsection-header-item.component";
import { SubsectionHeadersComponent } from "./subsection-headers.component";
import { SubsectionComponent } from "./subsection.component";

@NgModule({
  declarations: [
    SectionComponent,
    SidebarComponent,
    SidebarProjectedContentComponent,
    SubsectionHeadersComponent,
    SubsectionHeaderItemComponent,
    SubsectionComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CommonModule,
    LinkModule,
    FlexBoxModule,
    RouterModule,

    IconModule,
    UserActionDirectivesModule
  ],
  providers: [ScrollToService],
  exports: [SidebarComponent, SidebarProjectedContentComponent]
})
export class SidebarComponentModule {}
